/**
 * localStorage keys used across the app.
 * Centralised here so app/, features/, and pages/ can all import from @config/.
 */

/**
 * Set before redirecting a new dealer to /setup — signals that after onboarding completes
 * the user should land on the AI BDC page instead of the default orders page.
 * Uses localStorage so it survives the email verification link opening in a new tab.
 */
export const POST_SETUP_REDIRECT_KEY = 'ekho_post_setup_redirect';
